import type { CheckBoxList } from '@/components/myTicket/ticketDetail/viewModel'

export const handleRadioChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  list: CheckBoxList,
  setList: React.Dispatch<React.SetStateAction<CheckBoxList>>,
  setIsDisabled?: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const selectedValue = event.target.value
  const updatedRadioList = list.map((radio) =>
    radio.value === selectedValue ? { ...radio, checked: true } : { ...radio, checked: false }
  )

  if (setIsDisabled) {
    const isAnyChecked = updatedRadioList.some((radio) => radio.checked)
    setIsDisabled(!isAnyChecked)
  }

  setList([...updatedRadioList])
}
